export const PARTNER_API_DOCS_GET_STATISTICS_REQUEST_PARAMETERS = [
    {
        name: 'partner_id',
        description: 'partner.api_docs.partner_id_description',
        type: 'partner.api_docs.integer',
        required: true,
    },
    {
        name: 'api_key',
        description: 'partner.api_docs.api_key_description',
        type: 'partner.api_docs.string',
        required: true,
    },
    {
        name: 'group_type',
        description: 'partner.api_docs.methods.get_statistics.group_type_description',
        type: 'partner.api_docs.string',
        required: true,
    },
    {
        name: 'end_date',
        description: 'partner.api_docs.methods.get_statistics.end_date_description',
        type: 'partner.api_docs.string',
        required: false,
    },
    {
        name: 'start_date',
        description: 'partner.api_docs.methods.get_statistics.start_date_description',
        type: 'partner.api_docs.string',
        required: false,
    },
    {
        name: 'campaign_name',
        description: 'partner.api_docs.methods.get_statistics.campaign_name_request_description',
        type: 'partner.api_docs.string',
        required: false,
    },
    {
        name: 'campaign_channel',
        description: 'partner.api_docs.methods.get_statistics.campaign_channel_request_description',
        type: 'partner.api_docs.string',
        required: false,
    },
    {
        name: 'limit',
        description: 'partner.api_docs.limit_description',
        type: 'partner.api_docs.integer',
        required: false,
    },
    {
        name: 'offset',
        description: 'partner.api_docs.offset_description',
        type: 'partner.api_docs.integer',
        required: false,
    }
];

export const PARTNER_API_DOCS_GET_STATISTICS_RESPONSE_PARAMETERS = [
    {
        name: 'data',
        description: 'partner.api_docs.response_data',
        type: 'partner.api_docs.array',
    },
    {
        name: 'current_count',
        description: 'partner.api_docs.current_count',
        type: 'partner.api_docs.integer',
    },
    {
        name: 'total_count',
        description: 'partner.api_docs.total_count',
        type: 'partner.api_docs.integer',
    },
];

export const PARTNER_API_DOCS_GET_STATISTICS_RESPONSE_DATA_PARAMETERS = [
    {
        name: 'registered',
        description: 'partner.api_docs.methods.get_statistics.registered_response_description',
        type: 'partner.api_docs.string'
    },
    {
        name: 'profit',
        description: 'partner.api_docs.methods.get_statistics.profit_response_description',
        type: 'partner.api_docs.string'
    },
    {
        name: 'ftd',
        description: 'partner.api_docs.methods.get_statistics.ftd_response_description',
        type: 'partner.api_docs.string'
    },
    {
        name: 'turnover',
        description: 'partner.api_docs.methods.get_statistics.turnover_response_description',
        type: 'partner.api_docs.string'
    },
    {
        name: 'date',
        description: 'partner.api_docs.methods.get_statistics.date_response_description',
        type: 'partner.api_docs.string'
    },
    {
        name: 'campaign_name',
        description: 'partner.api_docs.methods.get_statistics.campaign_name_response_description',
        type: 'partner.api_docs.string'
    },
    {
        name: 'campaign_channel',
        description: 'partner.api_docs.methods.get_statistics.campaign_channel_response_description',
        type: 'partner.api_docs.string'
    },
    {
        name: 'uid',
        description: 'partner.api_docs.methods.get_statistics.uid_response_description',
        type: 'partner.api_docs.integer'
    }
];

export const PARTNER_API_DOCS_GET_STATISTICS_SAMPLE_REQUEST_DAY = `curl --location --request POST 'https://fx.binomo.com/api/v1/public/partner/statistics/get' \\
--header 'Content-Type: application/json' \\
--data-raw '{
    "api_key": "6d6a12d3cea4c1311d0a75d4909f0cc55ce09156e69c61873e35ce20d8467d34",
    "partner_id": 1,
    "group_type": "day",
    "start_date": "2022-08-01T00:00:00.000Z",
    "end_date":"2022-09-07T00:00:00.000Z",
    "limit": 1,
    "offset": 1
}'
`;

export const PARTNER_API_DOCS_GET_STATISTICS_SAMPLE_RESPONSE_DAY = `{
    "data": [
        {
            "date": "2022-09-02T00:00:00.000Z",
            "campaign_name": null,
            "campaign_channel": null,
            "registered": "0",
            "ftd": "1",
            "turnover": "0",
            "profit": "300.00000000"
        }
    ],
    "currentCount": 1,
    "totalCount": 2
}
`;

export const PARTNER_API_DOCS_GET_STATISTICS_SAMPLE_REQUEST_USER_ID = `curl --location --request POST 'https://fx.binomo.com/api/v1/public/partner/statistics/get' \\
--header 'Content-Type: application/json' \\
--data-raw '{
    "api_key": "6d6a12d3cea4c1311d0a75d4909f0cc55ce09156e69c61873e35ce20d8467d34",
    "partner_id": 1,
    "group_type": "user_id",
    "start_date": "2022-08-01T00:00:00.000Z",
    "end_date":"2022-09-07T00:00:00.000Z",
    "campaign_name": "un",
    "campaign_channel": "tele"
}'
`;

export const PARTNER_API_DOCS_GET_STATISTICS_SAMPLE_RESPONSE_USER_ID = `{
    "data": [
        {
            "uid": 64,
            "campaign_name": "uniq",
            "campaign_channel": "telegram",
            "registered_at": "2022-09-06T08:39:58.579Z",
            "registered": "1",
            "ftd": "0",
            "turnover": "0",
            "profit": "0"
        }
    ],
    "currentCount": 1,
    "totalCount": 1
}
`;
